import React, { lazy } from 'react';
import { useCheckout } from './CheckoutContext';
export function WhatsIncluded() {
  const {
    openUpsell,
    warmConnection
  } = useCheckout();
  const items = ['Reprogramación mental', 'Identidad', 'Manifestación consciente', 'Autoestima', 'Relaciones', 'Dinero', 'Energía', 'Hábitos', 'Propósito', 'Acción alineada'];
  return <section className="px-4 py-7 sm:py-9 border-t border-brand-gold/10" data-id="element-207">
      <div className="max-w-6xl mx-auto" data-id="element-208">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-2 leading-tight" data-id="element-209">
          ¿Qué incluye Realmanifestación?
        </h2>

        <p className="text-center text-sm sm:text-base text-brand-gray max-w-2xl mx-auto mb-5" data-id="element-210">
          Más de 200 protocolos, herramientas y ejercicios para transformar tu
          realidad desde adentro.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center mb-5" data-id="element-211">
          <div className="order-2 lg:order-1" data-id="element-212">
            <img src="https://cdn.magicpatterns.com/uploads/hvxLSXHiFPRBSASz9eWkeB/realmanifestacion_200kb.webp" alt="Realmanifestación" className="w-full max-w-sm mx-auto" loading="lazy" decoding="async" data-id="element-213" />
          </div>

          <div className="order-1 lg:order-2" data-id="element-214">
            <div className="grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-215">
              {items.map((item, i) => <div key={i} className="flex items-center gap-2 text-xs sm:text-sm" data-id="element-216">
                  <span className="text-brand-gold" data-id="element-217">✓</span>
                  <span data-id="element-218">{item}</span>
                </div>)}
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-219">
          <button onClick={openUpsell} onMouseEnter={warmConnection} onTouchStart={warmConnection} className="bg-brand-gold text-brand-black px-8 py-3.5 rounded text-base sm:text-lg font-bold hover:opacity-90 transition-all hover:scale-[1.02]" data-id="element-220">
            QUIERO ACCESO AHORA
          </button>
        </div>
      </div>
    </section>;
}